export default "__VITE_ASSET__BCrJH2OS__"